// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// :: State
const state = {
  pedidos: {},
  totalResults: 0,
  orderStatus: "",
  lastDocument: null
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
